import { useEffect } from "react";
import { Hub } from "@aws-amplify/core";
import { listener } from "./NewUserColumnSet";

export const HubListener = ({ children }) => {
  useEffect(() => {
    // Set up the Hub listener inside useEffect
    const unsubscribe = Hub.listen("auth", listener);

    // Cleanup function - this is crucial for React 18
    return () => {
      unsubscribe();
    };
  }, []); // Empty dependency array - runs once on mount

  return children;
};
